/* eslint-disable max-lines */
export enum Brand {
    VISA = 'VISA',
    MASTERCARD = 'MASTERCARD',
    AMEX = 'AMEX',
    JCB = 'JCB',
    ELECTRON = 'ELECTRON',
    MAESTRO = 'MAESTRO',
    DINERS = 'DINERS',
    DINA = 'DINA',
    /** used for cards with no brand, e.g. loyalty card */
    NONE = 'NONE',
    /** used for cards where the brand cannot be determined */
    UNKNOWN = 'UNKNOWN',
}

export enum DirectDebitSetup {
    /** amount provided in minimalMonthlyAmount */
    FIXED_AMOUNT = 'FIXED_AMOUNT',
    /**  amount provided in minimalMonthlyAmount */
    MINIMAL_INSTALLMENT = 'MINIMAL_INSTALLMENT',
    NO_AUTOMATIC_REPAYMENT = 'NO_AUTOMATIC_REPAYMENT',
    /** amount provided in outstandingMonthlyAmount/remainingOutstandingMonthlyAmount */
    OUTSTANDING_AMOUNT = 'OUTSTANDING_AMOUNT',
}

export enum Type {
    /** used for debit card too */
    BANK_CARD = 'BANK_CARD',
    CREDIT = 'CREDIT',
    INDOOR = 'INDOOR',
    PREPAID = 'PREPAID',
    VIRTUAL_CREDIT = 'VIRTUAL_CREDIT',
    VIRTUAL_DEBIT = 'VIRTUAL_DEBIT',
}

export enum Provider {
    ERSTE_BANK = 'ERSTE_BANK',
    EXTERNAL = 'EXTERNAL',
}

export enum State {
    ACTIVE = 'ACTIVE',
    /** Issued card not activated yet */
    INACTIVE = 'INACTIVE',
    /** Permanently blocked */
    LOCKED = 'LOCKED',
    /** Could be unblocked to be active */
    TEMPORARY_BLOCKED = 'TEMPORARY_BLOCKED',
    /** Expired, canceled */
    CLOSED = 'CLOSED',
    /** New card has been ordered */
    ORDERED = 'ORDERED',
    /** Newly ordered card has been shipped to user */
    SHIPPED = 'SHIPPED',
    /** Newly ordered card should be expected by user to be delivered shortly */
    IN_DELIVERY = 'IN_DELIVERY',
    /** The card was not successfully delivered to user */
    NOT_DELIVERED = 'NOT_DELIVERED',
}

export enum LockReason {
    DELINQUENCY = 'DELINQUENCY',
    FRAUD = 'FRAUD',
    LOSS = 'LOSS',
    NEVER_RECEIVED = 'NEVER_RECEIVED',
    OTHER = 'OTHER',
    SOLVENCY = 'SOLVENCY',
    THEFT = 'THEFT',
}

/** @deprecated Indicates how credit card invoices are delivered - DEPRECATED, GET ../statements/delivery call should be used instead */
export enum InvoiceDeliveryMode {
    ELECTRONICALLY = 'ELECTRONICALLY',
    POSTAL = 'POSTAL',
}

export enum CardDeliveryMode {
    ADDRESS_ABROAD = 'ADDRESS_ABROAD',
    BRANCH = 'BRANCH',
    BRANCH_PROLONGATION = 'BRANCH_PROLONGATION',
    HOME = 'HOME',
    OTHER_BRANCH = 'OTHER_BRANCH',
    PHONE_NUMBER = 'PHONE_NUMBER',
}

export enum PinDeliveryMode {
    ADDRESS_ABROAD = 'ADDRESS_ABROAD',
    BANK_APPLICATION = 'BANK_APPLICATION',
    BRANCH = 'BRANCH',
    BRANCH_PROLONGATION = 'BRANCH_PROLONGATION',
    EMAIL = 'EMAIL',
    HOME = 'HOME',
    MULTIPLE = 'MULTIPLE',
    OTHER_BRANCH = 'OTHER_BRANCH',
    PHONE_NUMBER = 'PHONE_NUMBER',
    PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
}

export enum DeliverySubject {
    CARD = 'CARD',
    PIN = 'PIN',
}

export enum ContactType {
    ADDRESS = 'ADDRESS',
    EMAIL = 'EMAIL',
    PHONE = 'PHONE',
}

export enum Feature {
    /** NEW TBD - Display Instalment Plans menu item on the card's navigation bar, above Product Settings menu item */
    cardInstallments = 'cardInstallments',
    /** Indicates that activation functionality is allowed on this card and displayed to user */
    activateCard = 'activateCard',
    /** Indicates whether contactless functionality is available on this card and displayed to user */
    contactless = 'contactless',
    /** Indicates whether 3D secure online shopping is available on this card and displayed to user */
    secureOnlineShopping = 'secureOnlineShopping',
    /** Indicates whether card delivery setting could be displayed to user */
    cardDelivery = 'cardDelivery',
    /** Indicates whether PIN delivery setting could be displayed to user */
    pinDelivery = 'pinDelivery',
    /** Indicates that automatic replacement of this card is displayed to user */
    automaticReplacement = 'automaticReplacement',
    /** Indicates that a replacement card feature could be displayed to user */
    replacementCard = 'replacementCard',
    /** Indicates whether reissuing card feature could be displayed to user */
    reissueCard = 'reissueCard',
    /** Indicates whether a card can be locked online by user */
    onlineLocking = 'onlineLocking',
    /** Indicates that cancel card feature could be displayed to user */
    cancelCard = 'cancelCard',
    /** Indicates whether automatic repayment (setup for Direct Debit) of credit card is possible and displayed to user */
    directDebitRepayment = 'directDebitRepayment',
    /** Indicates whether online repayment of credit card is possible for user */
    onlineRepayment = 'onlineRepayment',
    /** Indicates that card limits feature could be displayed to user */
    limitChange = 'limitChange',
    /** Indicates that card temporary limits feature could be displayed to user */
    temporaryLimitChange = 'temporaryLimitChange',
    /** Indicates whether functionality for reprint of existing PIN is available on this card and displayed to user - ideally business replaces this functionality by displayPin */
    reprintPin = 'reprintPin',
    /** Indicates whether reissuing a PIN is possible and displayed to user */
    reissuePin = 'reissuePin',
    /** Indicates that authorized (supplementary) cards exist for this card. */
    authorizedCards = 'authorizedCards',
    /** Indicates whether linked account information would be available (used only in AT), since only there card could be linked to more accounts), HU could be linked to a single account */
    accountLinkage = 'accountLinkage',
    /** Indicates whether user may see the electronic statements list and download statement for credit card (shadow account). */
    electronicStatement = 'electronicStatement',
    /** Indicates whether functionality of Quick drawdown from Credit Card is available and displayed to user */
    onlineDrawdown = 'onlineDrawdown',
    /** Indicates whether card is tokenizable in specific mobile payment application on particular mobile device (This feature is provided only in card list call, when application ID and optionally device ID are provided in request query parameters. It is returned if there's no existing token for given device. Mobile payment application decides if the card is tokenizable with given tokenLibraryType.) */
    cardTokenization = 'cardTokenization',
    /** Indicates whether card tokenization functionality is supported by the bank (in general, not for specific application ID or device ID) */
    cardTokenizationSupported = 'cardTokenizationSupported',
    /** Indicates the card is eligible for usage with a transaction analysis based marketing offers - service such as Dateio */
    transactionsAnalysisMarketing = 'transactionsAnalysisMarketing',
    /** Indicates that functionality for Secured Info (PIN, PAN, CVC) display is available on this card */
    displaySecuredInfo = 'displaySecuredInfo',
    /** Indicates if card has the external loyalty program */
    loyaltyProgramExternal = 'loyaltyProgramExternal',
    /** @deprecated - Indicates that functionality for PIN setting is available on this card and displayed to user. - This feature should be replaced by using 'displaySecuredInfo' */
    displayPin = 'displayPin',
    /** @deprecated - Indicates whether invoice delivery for statements can be switched between postal and electronical. - This feature should be replaced by using `electronicStatement` */
    invoiceDelivery = 'invoiceDelivery',
    /** @deprecated - Indicates whether SMS notifications for this card can be set. - Only used in AT, local feature, no part of Group Spec */
    smsNotifications = 'smsNotifications',
    /** @deprecated - Indicates whether watch dogs for this card can be set. - Not used on George FE, will be removed from Group Spec */
    watchDogs = 'watchDogs',
    /** @deprecated - Indicates that this card could be switched to REVOLVING mode. - Only used in AT, local feature, no part of Group Spec, this feature should be replaced by feature `directDebitRepayment` */
    revolving = 'revolving',
    /** @deprecated - Indicates that several functions could be temp. deactivated for this (EB credit) card. - Not used on George FE, will be removed from Group Spec */
    temporarilyDeactivation = 'temporarilyDeactivation',
    /** @deprecated - Indicates that the available to spend amount for a EB credit card can be increased by transferring money from a current account. - Not used on George FE, will be removed from Group Spec */
    availableAmount = 'availableAmount',
    /** @deprecated */
    automaticRepayment = 'automaticRepayment',
    selfService = 'selfService',
    replaceExpiringCard = 'replaceExpiringCard',
}

export enum CustomFeature {
    /** CZ - It is possible to issue the unlock card action if card identified by {id} parameter does have feature */
    onlineUnlocking = 'onlineUnlocking',
    /** CZ Indicates that the card has the card design change feature */
    changeCardDesign = 'changeCardDesign',
    /** CZ - Indicates that dynamic currency conversion can be enabled */
    dynamicCurrencyConversionEnabling = 'dynamicCurrencyConversionEnabling',
    /** CZ - Indicates that dynamic currency conversion can be disabled */
    dynamicCurrencyConversionDisabling = 'dynamicCurrencyConversionDisabling',
    /** AT - geo control */
    geoControl = 'geoControl',
    /** AT - Indicates whether adding more money to a card is possible */
    reloadCard = 'reloadCard',
    /** AT - Indicates whether repersonalizing a card is possible */
    repersonalizeCard = 'repersonalizeCard',
    /** AT - onlineLockingIndicates whether it is possible to lock and reorder the card (in one step) */
    lockReorderCard = 'lockReorderCard',
    /** AT - Indicates that “SB deckelungs limits” could be changed for this (bank) card */
    sbDeckelungsLimitChange = 'sbDeckelungsLimitChange',
    /** AT - Indicates that “SB deckelungs limits” could be reset for this (bank) card */
    sbDeckelungsLimitReset = 'sbDeckelungsLimitReset',
    /** AT - Indicates that “SB deckelungs limits” could be changed for this card */
    sbDeckelungsLimit = 'sbDeckelungsLimit',
    /** AT - Indicates that the limit could be altered for this (EB credit) card */
    creditCardLimitChange = 'creditCardLimitChange',
    /** AT - Indicates that several transaction types could be temp. deactivated for this (EB credit) card */
    temporaryDeactivation = 'temporaryDeactivation',
    /** AT - Indicates whether resetting NFC for micro card is allowed */
    resetNfc = 'resetNfc',
    /** AT - Indicates whether availableAmounts information is shipped with a card’s data */
    creditCardAvailableAmounts = 'creditCardAvailableAmounts',
    /** AT - Indicates whether the increase of the available amount on sCreditCards is supported */
    increaseCreditCardAvailableAmount = 'increaseCreditCardAvailableAmount',
    /** AT - Temporary deactivation */
    restrictAtmTransactions = 'restrictAtmTransactions',
    /** AT - Temporary deactivation */
    restrictEcomTransactions = 'restrictEcomTransactions',
    /** AT - Temporary deactivation */
    restrictPosTransactions = 'restrictPosTransactions',
    /** AT - Indicates that the loyalty program hybrid page entry point should be displayed and, if flag doesn't overrule it, made accessible to the user */
    'at-loyaltyProgramExternal' = 'at-loyaltyProgramExternal',
    /** SK - Indicates whether to render notifications component */
    smsNotificationAllowed = 'sk-smsNotificationAllowed',
    /** AT - Indicates that hybrid card migration external page entry point for the card should be enabled */
    'at-creditCardMigrationExternal' = 'at-creditCardMigrationExternal',
    /** AT GB - Indicates that the card should show atm withdrawals, card and/or online payments */
    channelsChange = 'channelsChange',
    /** AT GB - Indicates that this card is a child of an umbrella card */
    childOfUmbrellaCard = 'childOfUmbrellaCard',
    /** AT GB - Indicates that this card has pending card holder invitation */
    invitationEnabled = 'invitationEnabled',
    onlineTemporaryLocking = 'onlineTemporaryLocking',
    lockAndReplaceCard = 'lockAndReplaceCard',
}

export enum Flag {
    /** User can enter/create new installment plan on particular credit card */
    cardInstallmentsEntryAllowed = 'cardInstallmentsEntryAllowed',
    /** NEW TBD - Display Instalment Plans menu item on the account's navigation bar, above Product Settings menu item */
    cardInstallmentsAllowed = 'cardInstallmentsAllowed',
    /** Indicates that contactless functionality is active for this card */
    contactlessEnabled = 'contactlessEnabled',
    /** Indicates that 3D secure online shopping functionality is active for this card */
    secureOnlineShoppingEnabled = 'secureOnlineShoppingEnabled',
    /** Indicates that 3D secure online shopping setting couldn't be changed by user for this card */
    secureOnlineShoppingChangeNotAllowed = 'secureOnlineShoppingChangeNotAllowed',
    /** Indicates that 3D secure online shopping status (activate/deactivate functionality) couldn't be changed by user for this card */
    secureOnlineShoppingStatusChangeNotAllowed = 'secureOnlineShoppingStatusChangeNotAllowed',
    /** Indicates that card delivery setting couldn't be changed by user for this card */
    cardDeliveryChangeNotAllowed = 'cardDeliveryChangeNotAllowed',
    /** Indicates that PIN delivery setting couldn't be changed by user for this card */
    pinDeliveryChangeNotAllowed = 'pinDeliveryChangeNotAllowed',
    /** Indicates that automatic card replacement is active for given card */
    automaticReplacementEnabled = 'automaticReplacementEnabled',
    /** Indicates that user is not allowed to change automatic card replacement setting for given card */
    automaticReplacementChangeNotAllowed = 'automaticReplacementChangeNotAllowed',
    /** Indicates that user is not allowed to ask for card replacement for given card, e.g. because card is already LOCKED, CLOSED */
    replacementCardNotAllowed = 'replacementCardNotAllowed',
    /** Indicates that user is not allowed to ask for card reissue for given card, e.g. because card is already LOCKED, CLOSED */
    reissueCardNotAllowed = 'reissueCardNotAllowed',
    /** Indicates that user is not allowed to do online locking for given card, e.g. because card is already LOCKED, CLOSED */
    onlineLockingNotAllowed = 'onlineLockingNotAllowed',
    /** Indicates that user can do online unlocking for given card (only in CZ so far), e.g. because card is already LOCKED, CLOSED */
    onlineUnlockingAllowed = 'onlineUnlockingAllowed',
    /** Indicates that user is not allowed to do cancel for given card, e.g. because card is already LOCKED, CLOSED or bank doesn't allow it online */
    cancelCardNotAllowed = 'cancelCardNotAllowed',
    /** Indicates that user is not allowed to ask for automatic repayment (Direct Debit) of this credit card */
    directDebitRepaymentNotAllowed = 'directDebitRepaymentNotAllowed',
    /** Indicates that user is not allowed to ask for automatic repayment (Direct Debit) of this credit card, since user has no account from which Direct Debit could be done */
    directDebitRepaymentNoAccount = 'directDebitRepaymentNoAccount',
    /** Indicates that user is not allowed to change method of automatic repayment (Direct Debit) of this credit card (could change account for Direct Debit only) */
    directDebitRepaymentMethodChangeNotAllowed = 'directDebitRepaymentMethodChangeNotAllowed',
    /** Indicates that user is not allowed to do online repayment for this credit card */
    onlineRepaymentNotAllowed = 'onlineRepaymentNotAllowed',
    /** Indicates that user is not allowed to do online repayment for this credit card, since user has no account from which repayment could be done */
    onlineRepaymentNoAccount = 'onlineRepaymentNoAccount',
    /** Indicates that user is not allowed to do limit change for this card */
    limitChangeNotAllowed = 'limitChangeNotAllowed',
    /** Indicates that temporary limit setup is active for given card */
    temporaryLimitActivated = 'temporaryLimitActivated',
    /** Indicates that user is not allowed to do temporary limit change for this card */
    temporaryLimitChangeNotAllowed = 'temporaryLimitChangeNotAllowed',
    /** Indicates that user is not allowed to ask for PIN reprint for this card */
    reprintPinNotAllowed = 'reprintPinNotAllowed',
    /** Indicates that user is not allowed to do PIN reissue for this card */
    reissuePinNotAllowed = 'reissuePinNotAllowed',
    /** Indicates that secured info - PIN, can be shown to the user for this card */
    displayPinAllowed = 'displayPinAllowed',
    /** Indicates that secured info - PAN (full card number), can be shown to the user for this card */
    displayPanAllowed = 'displayPanAllowed',
    /** Indicates that secured info - CVC (Card Verification Code printed on back side of card), can be shown to the user for this card */
    displayCvcAllowed = 'displayCvcAllowed',
    /** Indicates that secured info - PAN together with CVC (full card number and Card Verification Code), can be shown to the user for this card. If this flag is sent then both values will be provided in one call requesting secured info. The dedicated flags "displayPanAllowed" and "displayCvcAllowed" have to be sent to support only PAN or only CVC separately. */
    displayPanCvcAllowed = 'displayPanCvcAllowed',
    /** Indicates that secured info - PAN together with CVC (full card number and Card Verification Code), can be shown to the user for this card in external page as redirect to provided link. If this flag is sent then both values will be displayed out of the George. */
    displayPanCvcExternalAllowed = 'displayPanCvcExternalAllowed',
    /** Indicates that secured info - 3D Secure Code (Code used to confirm internet payments via Credit card) can be (re)generate for this card by user */
    generate3dSecureCodeAllowed = 'generate3dSecureCodeAllowed',
    /** Indicates that there are possible orphaned tokens for mobile application/device (This flag is provided only in card list call, when application ID and device ID are provided in request query parameters) */
    orphanedTokensEnabled = 'orphanedTokensEnabled',
    /** @deprecated - Indicates that SMS notification is active for this card - Not used on George FE, will be removed from Group Spec */
    smsNotificationActive = 'smsNotificationActive',
    /** @deprecated - Indicates whether - for an internal credit card that is a business card - the card is used as a business card - Not used on George FE, will be removed from Group Spec */
    businessCardUsage = 'businessCardUsage',
    /** @deprecated - Indicates that credit card has revolving mode - Only used in AT, local feature, no part of Group Spec, this feature should be replaced by feature `directDebitRepayment` */
    revolving = 'revolving',
    /** @deprecated */
    activationAllowed = 'activationAllowed',
    /** @deprecated */
    automaticReplacementOn = 'automaticReplacementOn',
    /** @deprecated */
    automaticRepaymentActive = 'automaticRepaymentActive',
    /** @deprecated */
    electronicStatementAllowed = 'electronicStatementAllowed',
    /** AT - the card is a micro card of type chip */
    microChip = 'microChip',
    /** AT - the card is a micro card of type sticker */
    microSticker = 'microSticker',
    /** AT - the card is a debit mobile card */
    debitMobile = 'debitMobile',
    directDebitAllowed = 'directDebitAllowed',
    EBCC = 'EBCC',
    ownTransferAllowed = 'ownTransferAllowed',
    domesticTransferAllowed = 'domesticTransferAllowed',
    internationalTransferAllowed = 'internationalTransferAllowed',
    virtualCard = 'virtualCard',
    aliasLicenseChangeAllowed = 'aliasLicenseChangeAllowed',
    junior = 'junior',
    lockAndReplaceCardAllowed = 'lockAndReplaceCardAllowed',
    selfServiceAllowed = 'selfServiceAllowed',
    expiring = 'expiring',
    replaceExpiringCardAllowed = 'replaceExpiringCardAllowed',
    skipStoreAllowed = 'skipStoreAllowed',
}

export enum CustomFlag {
    /** AT - the card is a micro card of type chip */
    microChip = 'microChip',
    /** AT - the card is a micro card of type sticker */
    microSticker = 'microSticker',
    /** AT - the card is a debit mobile card */
    debitMobile = 'debitMobile',
    /** CZ Indicates that the user is not allowed to change the design of the card */
    changeCardDesignNotAllowed = 'changeCardDesignNotAllowed',
    /** AT - Indicates (when coupled with the feature "at-loyaltyProgramExternal") that the loyalty program hybrid page box/function detail should ONLY be DISPLAYED, however CANNOT be accessed by the user */
    'at-loyaltyProgramExternalNotAllowed' = 'at-loyaltyProgramExternalNotAllowed',
    /** AT - the card is a zero limit credit card */
    'at-zeroLimitCreditCard' = 'at-zeroLimitCreditCard',
    /** AT - Indicates that credit card cannot be changed to zero limit credit card because there is open balance */
    'at-zeroLimitCreditCardOpenBalance' = 'at-zeroLimitCreditCardOpenBalance',
    /** Indicates that credit card cannot be changed to zero limit credit card because there is revolving repayment method */
    'at-zeroLimitCreditCardRevolving' = 'at-zeroLimitCreditCardRevolving',
    /** Indicates that credit card cannot be changed to zero limit credit card because there are open instalments (split now plan) */
    'at-zeroLimitCreditCardOpenInstallmentPlan' = 'at-zeroLimitCreditCardOpenInstallmentPlan',
    /** Indicates that credit card cannot be changed to zero limit credit card because there is open reservation */
    'at-zeroLimitCreditCardOpenReservation' = 'at-zeroLimitCreditCardOpenReservation',
    /** Indicates that credit card can be changed to zero limit credit card when the card does not include either:
     * "at-zeroLimitCreditCardOpenBalance",
     * "at-zeroLimitCreditCardRevolving",
     * "at-zeroLimitCreditCardOpenInstallmentPlan",
     * "at-zeroLimitCreditCardOpenReservation" */
    'at-zeroLimitCreditCardAvailable' = 'at-zeroLimitCreditCardAvailable',
    /** AT GB - Indicates that the card is not allowed to edit atm withdrawals, card and/or online payments  */
    channelsChangeNotAllowed = 'channelsChangeNotAllowed',
    /** Indicates that the card has at least one payment protection insurance */
    'cz-hasProductFeaturePPI' = 'cz-hasProductFeaturePPI',
    /** CZ GB - Indicates that the card replacement is allowed for the user */
    replacementCardAllowed = 'replacementCardAllowed',
    onlineTemporaryLockingAllowed = 'onlineTemporaryLockingAllowed',
}

export enum LimitType {
    ATM = 'ATM',
    INTERNET = 'INTERNET',
    POS = 'POS',
    TOTAL = 'TOTAL',
}

export enum LimitPeriod {
    D1 = '1D',
    D2 = '2D',
    D3 = '3D',
    D5 = '5D',
    D7 = '7D',
    D10 = '10D',
    D14 = '14D',
    D15 = '15D',
    D30 = '30D',
}

export enum LimitFlag {
    /** means no limit amount for limit type and period */
    unlimited = 'unlimited',
    /** means no temporary limit amount for limit type */
    temporaryUnlimited = 'temporaryUnlimited',
    /** means "unlimited" will be part of the dropdown list */
    allowedLimitsWithUnlimited = 'allowedLimitsWithUnlimited',
}

export enum Language {
    cs = 'cs',
    de = 'de',
    en = 'en',
    hr = 'hr',
    hu = 'hu',
    ro = 'ro',
    sk = 'sk',
    sr = 'sr',
}

export enum Action {
    CLOSE_CARD = 'CLOSE_CARD',
    REISSUE_PIN = 'REISSUE_PIN',
    REPRINT_PIN = 'REPRINT_PIN',
    REISSUE_CARD = 'REISSUE_CARD',
    LOCK_CARD = 'LOCK_CARD',
    LOCK_AND_REPLACE_CARD = 'LOCK_AND_REPLACE_CARD',
    UNLOCK_CARD = 'UNLOCK_CARD',
    REPLACE_CARD = 'REPLACE_CARD',
    ACTIVATE_CARD = 'ACTIVATE_CARD',
    SET_CONTACTLESS_ON = 'SET_CONTACTLESS_ON',
    SET_CONTACTLESS_OFF = 'SET_CONTACTLESS_OFF',
    SET_AUTOMATIC_REPLACEMENT_ON = 'SET_AUTOMATIC_REPLACEMENT_ON',
    SET_AUTOMATIC_REPLACEMENT_OFF = 'SET_AUTOMATIC_REPLACEMENT_OFF',
    DISABLE_DYNAMIC_CURRENCY_CONVERSION = 'DISABLE_DYNAMIC_CURRENCY_CONVERSION',
    ENABLE_DYNAMIC_CURRENCY_CONVERSION = 'ENABLE_DYNAMIC_CURRENCY_CONVERSION',
    TEMPORARILY_LOCK_CARD = 'TEMPORARILY_LOCK_CARD',
}

export enum TransferType {
    /** request of Repayment (pay off) of Credit Card debt from selected user's current account */
    DEBT_REPAYMENT = 'DEBT_REPAYMENT',
    /** request of Credit Card limit increase from selected user's current account */
    LIMIT_INCREASE = 'LIMIT_INCREASE',
    /** request of Quick drawdown from Credit Card to any account defined by user (available for domestic payment) */
    QUICK_DRAWDOWN = 'QUICK_DRAWDOWN',
}

export enum CipherAlgorithm {
    AES = '2.16.840.1.101.3.4.1.42',
    TripleDES = '1.2.840.113549.3.7',
    PlainText = 'PLAIN_TEXT',
}

export enum SecuredInfoType {
    ACCOUNT_STATEMENT_PASSWORD = 'ACCOUNT_STATEMENT_PASSWORD',
    CARD_CVC = 'CARD_CVC',
    CARD_PAN = 'CARD_PAN',
    CARD_PIN = 'CARD_PIN',
    CARD_STATEMENT_PASSWORD = 'CARD_STATEMENT_PASSWORD',
    LOGIN_PIN = 'LOGIN_PIN',
    SECURE_CODE = '3D_SECURE_CODE',
}

export enum SecuredInfoProductType {
    ACCOUNTS = 'ACCOUNTS',
    BUILDINGS = 'BUILDINGS',
    CARDS = 'CARDS',
    INSURANCES = 'INSURANCES',
    LEASINGS = 'LEASINGS',
    PENSIONS = 'PENSIONS',
    SECURITIES = 'SECURITIES',
}

export enum GeoControlMode {
    active = 'active',
    inactive = 'inactive',
    notAvailable = 'notAvailable',
    suspended = 'suspended',
}

export enum CardType {
    MAIN = 'H',
    ADDITIONAL = 'Z',
}

export enum FeeType {
    KA_ERSATZKAR = 'KA-ERSATZKAR',
    KA_KDIG = 'KA-KDIG',
    KA_KDIGERST = 'KA-KDIGERST',
    KA_KK = 'KA-KK',
    KA_KKERST = 'KA-KKERST',
    KA_KKSPERR = 'KA-KKSPERR',
    KA_KKZU = 'KA-KKZU',
    KA_KKZUERST = 'KA-KKZUERST',
    KA_KAR_NACHB = 'KA-KAR-NACHB',
    KA_PIN_NACHB = 'KA-PIN-NACHB',
    KA_BKAIRERST = 'KA-BKAIRERST',
    KA_BKAIR = 'KA-BKAIR',
    KA_BKERST = 'KA-BKERST',
    KA_BK = 'KA-BK',
    KA_PIN_ABR = 'KA-PIN-ABR',
}

export enum Characteristic {
    /** main card and user has full rights */
    MAIN = 'MAIN',
    /** usually supplementary card */
    AUTHORIZED = 'AUTHORIZED',
    /** supplementary card and user has limited rights to card and no access to main account of this debit card */
    AUTHORIZED_STANDALONE = 'AUTHORIZED_STANDALONE',
}

export enum AmountType {
    DRAWN_AMOUNT = 'drawnAmount',
    LAST_OWED_AMOUNT = 'lastOwedAmount',
    MINIMAL_MONTHLY_AMOUNT = 'minimalMonthlyAmount',
    OVER_DUE_AMOUNT = 'overDueAmount',
    REMAINING_OUTSTANDING_AMOUNT = 'remainingOutstandingMonthlyAmount',
}
